import { useState } from 'react';
import { Platform, StyleSheet } from 'react-native';

import FeatureFlags from '../../constants/FeatureFlags';
import Layout from '../../constants/Layout';
import { useForm } from '../../hooks/useForm';
import { PrimaryButton } from '../Button';
import { PhoneNumberInput } from '../PhoneInput';
import { TextBody } from '../StyledText';
import { TransparentView } from '../Themed';
import LeadFormFields from '../leadform/LeadFormFields';
interface SearchLeadFormProps {
  onSubmit: (phone: string) => void;
}

export default function SearchLeadForm({ onSubmit }: SearchLeadFormProps) {
  const { state, dispatch } = useForm({ phone: '' });
  const [submitted, setSubmitted] = useState(false);

  if (FeatureFlags.LEAD_FORM_V2) {
    return (
      <TransparentView style={styles.container}>
        <LeadFormFields />
      </TransparentView>
    );
  }

  return (
    <TransparentView style={styles.container} testID="v1">
      {submitted ? (
        <TextBody style={styles.description}>
          Thank you. We will text you when we have locations available in this
          city!
        </TextBody>
      ) : (
        <>
          <PhoneNumberInput
            testID="phone-input"
            style={styles.input}
            placeholder="Add your phone number and get notified"
            value={state.values.phone}
            error={state.errors.phone}
            onChangeText={(value) =>
              dispatch({ type: 'field', field: 'phone', value })
            }
            onBlur={() => dispatch({ type: 'validate', field: 'phone' })}
          />

          <PrimaryButton
            testID="submit-button"
            style={styles.button}
            title="Submit"
            disabled={!state.dirty || state.isInvalid}
            onPress={() => {
              onSubmit(state.values.phone);
              setSubmitted(true);
            }}
          />
        </>
      )}
    </TransparentView>
  );
}

const styles = StyleSheet.create({
  container: {
    ...Platform.select({
      web: {
        ...(Layout.isLargeDevice && {
          width: 360,
        }),
        ...(Layout.isMobileDevice && {
          width: '100%',
        }),
      },
    }),
  },
  description: {
    textAlign: 'center',
  },
  input: {
    width: '100%',
    marginTop: 12,
  },
  button: {
    marginTop: 10,
    width: '100%',
    ...Platform.select({
      web: {
        ...(Layout.isLargeDevice && {
          height: 60,
        }),
        ...(Layout.isMobileDevice && {
          height: 50,
        }),
      },
    }),
  },
});
